<script setup lang="ts">
defineProps({ blok: Object });
</script>

<template>
  <section class="pt-0 pb-9 bg-linear-to-br from-chsc-indigo-500 to-chsc-yellow max-[769px]:pt-20">
    <UiContainer>
      <div
        class="grid grid-cols-2 gap-x-12 items-center max-[769px]:grid-cols-1 max-[769px]:gap-x-0"
      >
        <div>
          <div class="mb-3 flex items-center justify-center text-white gap-4">
            <span class="fs-5xl">·</span>
            <img :src="blok?.icon.filename" :alt="blok?.icon.alt" />
            <span class="fs-5xl">·</span>
          </div>
          <h3 class="text-center fs-5xl font-londrina-solid text-chsc-yellow whitespace-pre-wrap">
            {{ blok?.title }}
          </h3>
        </div>
        <div class="global-hero-image">
          <img v-motion-slide-bottom :src="blok?.image.filename" :alt="blok?.image.alt" />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
